// extracted by mini-css-extract-plugin
export var addIngredientButton = "recipe-add-module--add-ingredient-button--d02da";
export var addRecipe = "recipe-add-module--add-recipe--fa006";
export var addStepButton = "recipe-add-module--add-step-button--ecfee";
export var content = "recipe-add-module--content--e83e3";
export var counter = "recipe-add-module--counter--5c3c1";
export var description = "recipe-add-module--description--ae57f";
export var form = "recipe-add-module--form--808a4";
export var formGroup = "recipe-add-module--form-group--3b7e3";
export var globalErrors = "recipe-add-module--global-errors--950cc";
export var hero = "recipe-add-module--hero--d1e1e";
export var ingredients = "recipe-add-module--ingredients--9277f";
export var inputBox = "recipe-add-module--input-box--662d7";
export var loading = "recipe-add-module--loading--47e2e";
export var preparations = "recipe-add-module--preparations--090c1";
export var success = "recipe-add-module--success--1dba8";
export var successButtons = "recipe-add-module--success-buttons--647b7";
export var successContent = "recipe-add-module--success-content--265d6";
export var switcher = "recipe-add-module--switcher--87baf";
export var title = "recipe-add-module--title--26e95";